const DividerBlockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path fill="#ffd400" d="M2 2h20v20H2z" />
    <path d="M0 0v24h24V0zm22 22H2V2h20z" fill="#333" />
    <path fill="#333" d="M20 11H4v2h16v-2z" />
  </svg>
);

export default DividerBlockIcon;
